<template>
	<div class="hxxq">
		<van-nav-bar
			title=""
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>
		<div class="header">
			<div class="xq1">
				<div class="xq-txt1 xq-left">
					预约日期：
				</div>
				<div class="xq-data1">
					{{xq.date}}
				</div>
			</div>
			<div class="xq2">
				<div class="xq-txt2 xq-left">
					预约人数：
				</div>
				<div class="xq-data2">
					{{xq.population}}
				</div>
			</div>
			<div class="xq3">
				<div class="xq-txt3 xq-left">
					申请单位：
				</div>
				<div class="xq-data3">
					{{xq.applicantName}}
				</div>
			</div>
			<div class="xq4">
				<div class="xq-txt4 xq-left">
					领队姓名：
				</div>
				<div class="xq-data4">
					{{xq.realname}}
				</div>
			</div>
			<div class="xq5">
				<div class="xq-txt5 xq-left">
					手机号：
				</div>
				<div class="xq-data5">
					{{xq.phone}}
				</div>
			</div>

			<div class="xq5">
				<div class="xq-txt5 xq-left">
					购买接驳车车票：
				</div>
				<div class="xq-data5">
					{{xq.buyTicket == 0 ? '否' : '是'}}
				</div>
			</div>

			<div class="xq6 xq-left">
				<div class="xq-p">
					图片
				</div>
			</div>
			<div class="plist xq-left">
				<!-- 云端使用 -->
				<div class="plist-box" v-for="(i,j)  in plist" :key="j">
					<img class="plist-p" :src="i | qiniuImageView(1, 70, 70)" mode=""/>
				</div>
				<!-- <div class="plist-box">
					<img class="plist-p" src="../../assets/images/bar1.png" mode=""/>
					<img class="plist-p" src="../../assets/images/bar2.png" mode=""/>
				</div> -->
			</div>
			<div class="xq7 xq-left">
				<div class="xq-txt7 xq-left">
					申报日期：
				</div>
				<div class="xq-data7">
					{{xq.ctime}}
				</div>
			</div>
		</div>
		<div class="btn" v-if="status == 1" >
			<div class="btn-box" @click="posthx">
				<img src="../../assets/images/btn.png"/>
				<div class="commit-text">确认核销</div>
			</div>
		</div>
	</div>
</template>

<script>
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from "@/utils/ui";
import { NavBar,Toast,} from 'vant';
import { delayAsync } from '@/utils/common'
	export default {
	components: {
        [NavBar.name]: NavBar
    },
		created() {
			let a = this.$route.query.id;
			this.id = a;
			this.getData();
		},
		data() {
			return {
				id:'',
				xq:{
					time:'2021-11-11',
					people:10,
					gs:'北京中科三环',
					ld:'张三',
					phone:12345678910,
					sbtime:'2024-11-11'
					},
				plist:[
					{
						url: '../../assets/images/video.png'
					},
				],
				status:"",
				}
		},
		methods: {
			onClickLeft(){
				this.$router.go(-2)
			},
			async getData(){
				let y = this.id;
				let data = {id:y}
				const promise = this.apiGet("hexiaoListXq",data);

				let apiResult = null;
				try {
					apiResult = await promise;
				} catch (ex) {
					apiResult = null;
				}

				if (this.isEmpty(apiResult)) {
					return;
				}

				console.log("apiResult",apiResult);

				this.xq = apiResult.obj;
				this.plist = apiResult.obj.imgs;
				this.status = apiResult.obj.status;
				// this.id = apiResult.obj.id;
				console.log("this.plist",this.plist);
				console.log("this.xq:",this.xq);
    		},

			async posthx(){
				let data = {id:this.id}
				const promise = this.apiPost("hexiao",data)

				let apiResult = null;

				try {
					apiResult = await promise;
					console.log("正常",apiResult)
					if(apiResult != null && apiResult != "" && apiResult != undefined){
						if(apiResult.errno == 1999){
							Toast.loading({
							message: apiResult.error,
							forbidClick: true,
							duration:1500
							});
					    }
						this.$router.go(-2)
					}
				} catch (ex) {
					console.log("出错",ex)
					apiResult = null;
					if(apiResult == null || apiResult == "" || apiResult == undefined){
					Toast.loading({
					message: '核销不成功',
					forbidClick: true,
					duration:1500
					});
					}

					this.$router.go(-2)
				}
				
				// console.log("核销接口返回",apiResult)

				
				// this.$router.go(-2)

				console.log("apiResult",apiResult);
			}

		}
	}
</script>

<style lang="less" scoped>
	.hxxq{
		overflow: hidden;
		.header{
			margin: 20px 20px 51px 20px;
			background: #FFFFFF;
			.xq1,.xq2,.xq3,.xq4,.xq5,.xq6{
				margin: 0 auto;
				border-bottom: 1px solid #E5E5E5;
				height: 100px;
				width: 710px;
				display: flex;
				align-items: center;
			}
			.xq-left{
				margin-left: 24px;
			}
			.xq-txt1{
				font-size: 14px;
				font-weight: 400;
				color:#030303;
				line-height: 0;
			}
			.xq-txt2{
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #030303;
				line-height: 0px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-data2{
				width: 48px;
				height: 56px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 20px;
				color: #FD4A46;
				line-height: 56px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-txt3{
				// width: 160px;
				height: 40px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 12px;
				color: #030303;
				line-height: 40px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-data3{
				height: 40px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				color: #030303;
				line-height: 40px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-txt4{
				// width: 160px;
				height: 40px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 12px;
				color: #030303;
				line-height: 40px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-data4{
				// width: 56px;
				height: 40px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				color: #030303;
				line-height: 40px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-txt5{
				// width: 112px;
				height: 40px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 12px;
				color: #030303;
				line-height: 40px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq-data5{
				width: 185px;
				height: 40px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 14px;
				color: #030303;
				line-height: 40px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
			.xq6{
				border:none;
				.xq-p{
					// width: 56px;
					height: 40px;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 14px;
					color: #000000;
					line-height: 40px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
			}
			.plist{
				display: flex;
				.plist-box{
					margin-left: 20px;
					display: flex;
					.plist-p{
						display:block;
						width: 140px;
						height: 140px;
						margin-left: 20px;
					}
				}
			}
			.xq7{
				margin-top: 69px;
				margin-bottom: 46px;
				display: flex;
				align-items: center;
				height: 100px;
				width: 710px;
				.xq-txt7{
					// width: 140px;
					height: 40px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #030303;
					line-height: 40px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
			}
		}
		.btn{
			width:640px;
			height: 88px;
			margin: 0 auto;
			margin-top: 51px;
			display: flex;
			align-items: center;
			.btn-box{
				position: relative;
				margin: 0 auto;
				// border: 1px solid red;
				width:640px;
				height: 88px;
				img{
					display: block;
					width: 640px;
					height: 88px;
					// position: relative;
				}
				.commit-text{
				   font-size: 16px;
					color: #FFFFFF;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%,-50%);
					z-index: 999;
				}
			}
		}
	}
</style>
